/**
 * Field type enum for ExtraSettings component
 */
const ExtraSettingsFieldTypeEnum = {
  TEXT: "TEXT",
  NUMBER: "NUMBER",
  DATE: "DATE",
  TIME: "TIME",
  CHECKBOX: "CHECKBOX",
  SELECT: "SELECT",
  TEXTAREA: "TEXTAREA",
  EMAIL: "EMAIL",
  PASSWORD: "PASSWORD",
  PHONE: "PHONE",
  URL: "URL",
  COLOR: "COLOR",
  FILE: "FILE",
  RANGE: "RANGE"
};

Object.freeze(ExtraSettingsFieldTypeEnum);

export default ExtraSettingsFieldTypeEnum;
